// Yearly and monthly Pro, each with and without the 7-day trial. Every audio-web paywall entry point
// (welcome offer, HQ, transcription, the tools limit) offers this same list, hardcoded in the client
// as it is there — so a pricing change needs a frontend release.
export const PAYWALL_PRO_PRODUCT_IDS = [
    'com.audio.pro.0.1.0.7.0.1.year.23966.8388',
    'com.audio.pro.0.0.0.0.0.1.year.23966.8388',
    'com.audio.pro.0.1.0.7.0.1.month.1899.1899',
    'com.audio.pro.0.0.0.0.0.1.month.1899.1899',
]

export const SEPARATION_TOOLS_TRIAL_PRODUCT_IDS = [
    'com.audio.pro.0.1.0.7.0.1.year.22788.8388.63off',
    'com.audio.pro.0.0.0.0.0.1.year.22788.8388.63off',
    'com.audio.pro.0.1.0.7.0.1.month.1899.1899',
    'com.audio.pro.0.0.0.0.0.1.month.1899.1899',
]

export const SEPARATION_TOOLS_NO_TRIAL_PRODUCT_IDS = [
    'com.audio.pro.0.0.0.0.0.1.year.22788.8388.63off',
    'com.audio.pro.0.0.0.0.0.1.month.1899.1899',
]

export const getSeparationToolsProductIds = (isTrialEnabled: boolean) =>
    isTrialEnabled ? SEPARATION_TOOLS_TRIAL_PRODUCT_IDS : SEPARATION_TOOLS_NO_TRIAL_PRODUCT_IDS
